<template>
  <div class="pageMyReservationInfo">
    <el-row :gutter="24">
      <el-col :span="12">
        <h2>{{ $t("pages.wording.reserve") }}</h2>
        <!--我的預約單-->
      </el-col>
      <el-col :span="12">
        <div v-if="parent" class="buttons c-form">
          <el-button class="blue-button button-right" @click="back" type="primary">{{
            $t("pages.button.back")
          }}</el-button
          ><!--關閉-->
        </div>
      </el-col>
    </el-row>
    <el-form label-width="120px">
      <el-collapse v-model="activeShowBlock">
        <el-collapse-item class="collapsecontent" name="basic">
          <template slot="title">
            <h3>{{ $t("pages.wording.basisInfo") }}</h3>
            <!--基本資訊-->
          </template>
          <div class="boxContain c-form">
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.reserveNo')" prop="reserveNo"
                  ><!--單號-->
                  <el-input :disabled="true" v-model="reserveItems.reserveNo"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.deltaContactName')" prop="deltaContactName"
                  ><!--台達接洽人-->
                  <el-input :disabled="true" v-model="reserveItems.deltaContactName"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.applyDate')" prop="applyDate"
                  ><!--預約日期-->
                  <el-input :disabled="true" v-model="reserveItems.applyDate"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.deltaContactNumber')" prop="deltaContactNumber"
                  ><!--接洽人電話-->
                  <el-input :disabled="true" v-model="reserveItems.deltaContactNumber"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.applicatorName')" prop="applicatorName"
                  ><!--填單人-->
                  <el-input :disabled="true" v-model="reserveItems.applicatorName"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.deltaContactMail')" prop="deltaContactMail"
                  ><!--接洽人Mail-->
                  <el-input :disabled="true" v-model="reserveItems.deltaContactMail"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <!--boxContain c-form-->
        </el-collapse-item>
        <el-collapse-item class="collapsecontent" name="reserve">
          <template slot="title">
            <h3>{{ $t("pages.wording.containForm") }}</h3>
            <!--填單內容-->
          </template>
          <div class="boxContain c-form">
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.oaCode')" prop="OACode"
                  ><!--OA Code-->
                  <el-input :disabled="true" v-model="reserveItems.OACode"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.vendor')" prop="vendor"
                  ><!--公司名稱-->
                  <el-input :disabled="true" v-model="reserveItems.vendor"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.reserveRegion')" prop="reserveRegion"
                  ><!--抵達地區-->
                  <el-input :disabled="true" v-model="reserveItems.reserveRegion"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.reserveArea')" prop="reserveArea"
                  ><!--抵達地區-->
                  <el-input :disabled="true" v-model="reserveItems.reserveArea"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.reserveFactory')" prop="reserveFactory"
                  ><!--抵達廠別-->
                  <el-input :disabled="true" v-model="reserveItems.reserveFactory"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.reserveLocation')" prop="reserveLocation"
                  ><!--抵達地點-->
                  <el-input :disabled="true" v-model="reserveItems.reserveLocation"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.vendorContactName')" prop="vendorContactName"
                  ><!--廠商聯絡人-->
                  <el-input :disabled="true" v-model="reserveItems.vendorContactName"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.vendorContactListNumber')" prop="vendorContactNumber"
                  ><!--廠商聯絡人電話-->
                  <el-input :disabled="true" v-model="reserveItems.vendorContactNumber"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.vendorContactMail')" prop="vendorContactMail"
                  ><!--廠商聯絡人Mail-->
                  <el-input :disabled="true" v-model="reserveItems.vendorContactMail"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.reserveArriveDate')" prop="reserveArriveDate"
                  ><!--預約進廠日期-->
                  <el-input :disabled="true" v-model="reserveItems.reserveArriveDate"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.enterReason')" prop="enterReason"
                  ><!--入廠事由-->
                  <el-input :disabled="true" v-model="reserveItems.enterReason"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.reserveArriveTime')" prop="reserveArriveTime"
                  ><!--預約進廠時間-->
                  <el-input :disabled="true" v-model="reserveItems.reserveArriveTime"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <!--boxContain c-form-->
        </el-collapse-item>
        <el-collapse-item class="collapsecontent" name="soTable" v-if="isGenerateByERP">
          <template slot="title">
            <div class="titleBtn">
              <h3>{{ $t("pages.wording.releaseOrderInfo") }}</h3>
            </div>
          </template>
          <div>
            <ReserveSOTable
              v-if="isGenerateByERP"
              :reserveID="reserveItems.id"
              :reserveCarPlat="reserveItems.carlicensePlat"
            />
          </div>
        </el-collapse-item>
        <el-collapse-item class="collapsecontent" name="carInfo" v-if="reserveItems.driverName != null">
          <template slot="title">
            <h3>{{ $t("pages.wording.carListInfo") }}</h3>
            <!--車輛資訊-->
          </template>
          <div class="boxContain c-form">
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.driverName')" prop="driverName"
                  ><!--司機姓名-->
                  <el-input :disabled="true" v-model="reserveItems.driverName"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.driverID')" prop="driverID"
                  ><!--司機ID-->
                  <el-input :disabled="true" v-model="reserveItems.driverID"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.carPlat')" prop="carlicensePlat"
                  ><!--車輛號牌-->
                  <el-input :disabled="true" v-model="reserveItems.carlicensePlat"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.driverPhone')" prop="driverPhone"
                  ><!--司機電話-->
                  <el-input :disabled="true" v-model="reserveItems.driverPhone"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.carType')" prop="carType"
                  ><!--車輛類型-->
                  <el-input :disabled="true" v-model="reserveItems.carType"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.carColor')" prop="carColor"
                  ><!--車輛顏色-->
                  <el-input :disabled="true" v-model="reserveItems.carColor"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <!--boxContain c-form-->
        </el-collapse-item>
        <el-collapse-item class="collapsecontent" name="entourageInfo" v-if="entourageInfo.length > 0">
          <template slot="title">
            <h3>{{ $t("pages.wording.entourageInfo") }}</h3>
            <!--隨行人員資訊-->
          </template>
          <div class="boxContain c-form">
            <ul class="boxSection list">
              <li v-for="(items, index) in entourageInfo" :class="`entourageInfo-${index}`" :key="items">
                <h4>{{ $t("pages.wording.entourage") }} {{ index + 1 }}</h4>
                <!--隨行人員-->
                <el-row :gutter="24">
                  <el-col :span="12">
                    <el-form-item :label="$t('pages.wording.entourageName')" prop="entourageName"
                      ><!--隨行人員姓名-->
                      <el-input :disabled="true" v-model="items.entourageName"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item :label="$t('pages.wording.entourageID')" prop="entourageID"
                      ><!--隨行人員ID-->
                      <el-input :disabled="true" v-model="items.entourageID"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </li>
            </ul>
            <!--boxSection-->
          </div>
          <!--boxContain-->
        </el-collapse-item>
        <el-collapse-item class="collapsecontent" name="carringInfo" v-if="carringInfo.length > 0">
          <template slot="title">
            <h3>{{ $t("pages.wording.carringInfo") }}</h3>
            <!--攜帶物資訊-->
          </template>
          <div class="boxContain c-form">
            <ul class="boxSection list">
              <li v-for="(items, index) in carringInfo" :class="`carryItemInfo-${index}`" :key="items">
                <h4>{{ $t("pages.wording.carring") }} {{ index + 1 }}</h4>
                <!--攜帶物-->
                <el-row :gutter="24">
                  <el-col :span="12">
                    <el-form-item :label="$t('pages.wording.carringType')" prop="carring"
                      ><!--攜帶物種類-->
                      <el-input :disabled="true" v-model="items.carring"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item :label="$t('pages.wording.carringNum')" prop="carringType"
                      ><!--攜帶物數量-->
                      <el-input :disabled="true" v-model="items.carringType"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </li>
            </ul>
            <!--boxSection-->
          </div>
          <!--boxContain-->
        </el-collapse-item>
        <el-collapse-item class="collapsecontent" name="inspectStatus">
          <template slot="title">
            <h3>{{ $t("pages.wording.inspectStatus") }}</h3>
            <!--檢查狀態-->
          </template>
          <div class="boxContain c-form">
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.entering')" prop="entering"
                  ><!--進廠檢查-->
                  <el-input
                    :disabled="true"
                    :value="inspectItem.entering ? $t('reserve.status.' + inspectItem.entering) : ''"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.stayTime')" prop="stayTime"
                  ><!--停車時間-->
                  <el-input :disabled="true" v-model="reserveItems.stayTime"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.in1')" prop="in1"
                  ><!--出廠初檢-->
                  <el-input
                    :disabled="true"
                    :value="inspectItem.in1 ? $t('reserve.status.' + inspectItem.in1) : ''"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.stayReason')" prop="stayReason"
                  ><!--停留原因-->
                  <el-input
                    :disabled="true"
                    :value="$store.getters.getSysCodeText('delayReason', reserveItems.stayReason)"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.in2')" prop="in2"
                  ><!--出廠復檢-->
                  <el-input
                    :disabled="true"
                    :value="inspectItem.in2 ? $t('reserve.status.' + inspectItem.in2) : ''"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <!--boxContain-->
        </el-collapse-item>
        <el-collapse-item class="collapsecontent" name="inspectRecord">
          <template slot="title">
            <h3>{{ $t("pages.wording.inspectRecord") }}</h3>
            <!--檢查紀錄-->
          </template>
          <el-table class="reserveLogTable" :data="reserveLog" border style="width: 100%" height="450px">
            <el-table-column type="index" width="50"></el-table-column>
            <el-table-column prop="reserveStatus" :label="$t('pages.wording.reserveStatus')" width="300"
              ><!--狀態-->
              <template slot-scope="scope">
                {{ $t("reserve.status." + scope.row.reserveStatus) }}
              </template>
            </el-table-column>
            <el-table-column prop="updateDate" :label="$t('pages.wording.updateDate')" width="120"> </el-table-column
            ><!--Update日期-->
            <el-table-column prop="updateTime" :label="$t('pages.wording.updateTime')" width="120"> </el-table-column
            ><!--Update時間-->
            <el-table-column prop="logOperator" :label="$t('pages.wording.logOperator')" width="120"> </el-table-column
            ><!--更新者-->
            <el-table-column prop="inspectRemark" :label="$t('pages.wording.remark')"> </el-table-column
            ><!--Remark-->
          </el-table>
        </el-collapse-item>
      </el-collapse>
      <div class="buttons c-form">
        <el-button class="blue-button button-right" @click="cencelApplication" type="primary">{{
          $t("pages.button.close")
        }}</el-button
        ><!--關閉-->
      </div>
    </el-form>
  </div>
  <!--pageMyReservationApply-->
</template>

<script>
import { store } from "@/store/store.js"
import { utils } from "@/utils/utils.js"
import ReserveSOTable from "@/components/Reserve/ReserveSOTable"
export default {
  name: "PageMyReservationInfoForAuth",
  components: {
    ReserveSOTable,
  },
  props: ["id", "parent", "parentName"],
  data() {
    return {
      reserveInfo: {},
      carringInfo: [],
      entourageInfo: [],
      inspectInfo: {},
      reserveLog: [],
      reserveItems: {
        id: -1,
        reserveNo: "",
        applyDate: "",
        OACode: "",
        reserveRegion: "",
        reserveArea: "",
        reserveFactory: "",
        reserveLocation: "",
        deltaContactNT: "",
        deltaContactName: "",
        deltaContactNumber: "",
        deltaContactMail: "",
        applicatorName: "",
        applicatorMail: "",
        applicatorNT: "",
        vendor: "",
        vendorContactName: "",
        vendorContactNumber: "",
        vendorContactMail: "",
        reserveArriveDate: "", //進廠日期
        reserveArriveTime: "", //進廠時間
        enterReason: "",
        tempCar: "",
        driverName: "",
        driverID: "",
        carlicensePlat: "",
        driverPhone: "",
        carType: "",
        carColor: "",
        stayReason: "",
        stayTime: "",
        reserveType: "",
      },
      inspectItem: {
        entering: "",
        in1: "",
        in2: "",
      },
      activeShowBlock: [
        "basic",
        "reserve",
        "soTable",
        "carInfo",
        "entourageInfo",
        "carringInfo",
        "inspectStatus",
        "inspectRecord",
      ],
      isGenerateByERP: false,
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      let reserveID = this.$props.id
      if (reserveID === 0 || reserveID === undefined) {
        reserveID = this.$route.query.id
      }
      this.getReserveInfo(reserveID)
    },
    /***************-FORM ACTIVE-***************/
    getReserveInfo(id) {
      this.$store.dispatch("getReserveInfo", { params: { id: id } })
    },
    buildReserveInfo(data) {
      var tmpcar
      if (data.tempCar == true) tmpcar = true
      else tmpcar = false

      this.reserveInfo = data
      this.reserveItems.id = data.id
      this.reserveItems.reserveNo = data.reserveNo

      this.reserveItems.applyDate = utils.getFormateDateTime("Date", data.applyDatetime)
      this.reserveItems.applicatorName = data.applicatorName
      this.reserveItems.applicatorNT = data.applicatorNT
      this.reserveItems.applicatorMail = data.applicatorMail
      this.reserveItems.deltaContactName = data.deltaContactName
      this.reserveItems.deltaContactNumber = data.deltaContactNumber
      this.reserveItems.deltaContactNT = data.deltaContactNT
      this.reserveItems.deltaContactDept = data.deltaContactDept
      this.reserveItems.deltaContactMail = data.deltaContactMail
      this.reserveItems.reserveRegion = data.reserveRegion
      this.reserveItems.reserveArea = data.reserveArea
      this.reserveItems.reserveFactory = data.reserveFactory
      this.reserveItems.reserveLocation = data.reserveLocation
      this.reserveItems.OACode = data.OACode
      this.reserveItems.vendor = data.vendor
      this.reserveItems.vendorContactName = data.vendorContactName
      this.reserveItems.vendorContactNumber = data.vendorContactNumber
      this.reserveItems.vendorContactMail = data.vendorContactMail
      this.reserveItems.reserveArriveDate = utils.getFormateDateTime("Date", data.reserveArriveDatetime)
      this.reserveItems.reserveArriveTime = utils.getFormateDateTime("Time", data.reserveArriveDatetime) //進廠時間
      this.reserveItems.enterReason = data.enterReason
      this.reserveItems.stayTime = data.stayTime
      this.reserveItems.stayReason = data.stayReason
      this.reserveItems.reserveType = data.reserveType

      this.reserveItems.driverName = !tmpcar ? data.driverName : data.tmpDriverName
      this.reserveItems.driverID = !tmpcar ? data.driverID : data.tmpDriverID
      this.reserveItems.carlicensePlat = !tmpcar ? data.carPlat : data.tmpCarPlat
      this.reserveItems.driverPhone = !tmpcar ? data.driverNumber : data.tmpDriverNumber
      this.reserveItems.carType = !tmpcar ? data.carType : data.tmpCarType
      this.reserveItems.carColor = !tmpcar ? data.carColor : data.tmpCarColor

      this.isGenerateByERP = this.reserveItems.reserveType === "ERP" || this.reserveItems.reserveType === "ERP_ONE"
    },
    buildCarringInfo(data) {
      this.carringInfo = data
    },
    buildEntourageInfo(data) {
      this.entourageInfo = data
    },
    buildInspectData(data) {
      this.inspectInfo = data
      this.inspectItem.entering = data.entering
      this.inspectItem.in1 = data.in1
      this.inspectItem.in2 = data.in2
    },
    buildReserveLog(data) {
      this.reserveLog = data

      data.forEach((item) => {
        var updateDate = new Date(item.updateDatetime)

        item.updateDate =
          updateDate.getFullYear() +
          "-" +
          (updateDate.getMonth() + 1 < 10 ? "0" : "") +
          (updateDate.getMonth() + 1) +
          "-" +
          (updateDate.getDate() < 10 ? "0" : "") +
          updateDate.getDate()
        item.updateTime =
          (updateDate.getHours() < 10 ? "0" : "") +
          updateDate.getHours() +
          ":" +
          (updateDate.getMinutes() < 10 ? "0" : "") +
          updateDate.getMinutes()
      })
    },
    cencelApplication() {
      this.$router.push({ path: "/MyReservation" })
    },
    back() {
      var parent = this.$props.parentName
      var parameter = { back: true }

      if (parent == "searchReserve") {
        this.$router.push({
          name: "PageSearchReservation",
          params: parameter,
        })
      }
    },
  },
  computed: {},
  watch: {
    "$store.getters.reserveInfo": function (datas) {
      var reserveData = datas.result
      this.buildReserveInfo(reserveData.reserveData)
      this.buildCarringInfo(reserveData.carringData)
      this.buildEntourageInfo(reserveData.entourageData)
      this.buildInspectData(reserveData.inspectData)
      this.buildReserveLog(reserveData.reserveLog)
    },
  },
}
</script>

<style>
.reserveLogTable th {
  background-color: #00a0e9;
  color: #fff;
}
</style>
